export default __webpack_public_path__ + "static/media/Aput_Icon.8013c901.png";